import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsBatchConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsBatchStack = createStackNavigator();

const BatchDetailsBatchNavigator = () => {
  return (
    <BatchDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchDetailsBatchConfig.map(({ Component, name }) => (
        <BatchDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsBatchStack.Navigator>
  );
};

export { BatchDetailsBatchNavigator };
